export const WbPartnersLogoTr = () => {
  return (
    <svg
      fill="none"
      height="29"
      viewBox="0 0 88 29"
      width="88"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.00195312 3.18218H7.6229L7.37294 6.68569H7.55516C8.6882 3.88874 11.5277 2.49219 14.0984 2.49219C19.6108 2.49219 22.3637 6.30017 22.3637 12.6924V25.1839H14.6061V13.148C14.6061 10.5768 13.363 9.29448 11.3455 9.29448C9.32801 9.29448 7.76608 10.7656 7.76608 13.6102V25.1839H0.00195312V3.18218Z"
        fill="#2C2B33"
      />
      <path
        d="M29.4795 11.0454L24.5659 11.9948V5.17203L37.3282 2.54028V25.1839H29.4795V11.0454Z"
        fill="#2C2B33"
      />
      <path
        d="M44.6504 11.0454L39.7368 11.9948V5.17203L52.4991 2.54028V25.1839H44.6504V11.0454Z"
        fill="#2C2B33"
      />
      <g clipPath="url(#clip0_285_40850)">
        <rect
          fill="#FF44EE"
          height="28.5586"
          rx="14.2793"
          width="28.5586"
          x="58.5859"
        />
        <path
          d="M60.9955 16.9928C65.3676 16.9928 68.9119 13.4485 68.9119 9.07642C68.9119 4.70432 65.3676 1.16003 60.9955 1.16003C56.6234 1.16003 53.0791 4.70432 53.0791 9.07642C53.0791 13.4485 56.6234 16.9928 60.9955 16.9928Z"
          fill="#2C2B33"
        />
        <path
          d="M78.0393 32.9276C83.64 32.9276 88.1802 28.3874 88.1802 22.7867C88.1802 17.1861 83.64 12.6459 78.0393 12.6459C72.4387 12.6459 67.8984 17.1861 67.8984 22.7867C67.8984 28.3874 72.4387 32.9276 78.0393 32.9276Z"
          fill="#2C2B33"
        />
        <path
          d="M77.5834 6.18046C80.5826 6.18046 83.014 3.74912 83.014 0.7499C83.014 -2.24932 80.5826 -4.68066 77.5834 -4.68066C74.5842 -4.68066 72.1528 -2.24932 72.1528 0.7499C72.1528 3.74912 74.5842 6.18046 77.5834 6.18046Z"
          fill="#2C2B33"
        />
        <g clipPath="url(#clip1_285_40850)">
          <rect
            fill="#FF44EE"
            height="28.5586"
            rx="14.2793"
            width="28.5586"
            x="58.5859"
          />
          <path
            d="M77.6478 31.679C82.893 31.679 87.1447 27.4273 87.1447 22.1821C87.1447 16.9369 82.893 12.6852 77.6478 12.6852C72.4026 12.6852 68.1509 16.9369 68.1509 22.1821C68.1509 27.4273 72.4026 31.679 77.6478 31.679Z"
            fill="#2C2B33"
          />
          <path
            d="M60.2468 17.4337C64.6104 17.4337 68.1508 13.8956 68.1508 9.53086C68.1508 5.16608 64.6116 1.62805 60.2468 1.62805C55.882 1.62805 52.3452 5.16608 52.3452 9.53086C52.3452 13.8956 55.8832 17.4337 60.2468 17.4337Z"
            fill="#2C2B33"
          />
          <path
            d="M77.6479 6.37535C80.2693 6.37535 82.3963 4.2495 82.3963 1.62689C82.3963 -0.995727 80.2693 -3.12036 77.6479 -3.12036C75.0265 -3.12036 72.8994 -0.994509 72.8994 1.62811C72.8994 4.25072 75.0265 6.37657 77.6479 6.37657V6.37535Z"
            fill="#2C2B33"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_285_40850">
          <rect
            fill="white"
            height="28.5586"
            rx="14.2793"
            width="28.5586"
            x="58.5859"
          />
        </clipPath>
        <clipPath id="clip1_285_40850">
          <rect
            fill="white"
            height="28.5586"
            rx="14.2793"
            width="28.5586"
            x="58.5859"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
